export const searchKeywords = [
  {
    name: "Row",
    keywords: ["row", "column", "section", "div", "responsive", "layout"]
  },
  {
    name: "Header",
    keywords: ["header", "fixed", "nav", "navbar", "navigation", "menu", "navigation"]
  },
  {
    name: "Footer",
    keywords: ["footer", "fixed", "footer", "footer", "footer", "footer"]
  },
  {
    name: "Spacer",
    keywords: ["spacer", "gutter", "gap", "panel"]
  },
  {
    name: "HorizontalStack",
    keywords: ["horizontal", "stack", "space", "gutter", "gap", "panel"]
  },
  {
    name: "VerticalStack",
    keywords: ["vertical", "stack", "space", "gutter", "gap", "panel"]
  },
  {
    name: "Panel",
    keywords: ["panel", "container", "box"]
  },
  {
    name: "Collapse",
    keywords: ["collapse", "panel", "accordion"]
  },
  {
    name: "Tab",
    keywords: ["tab", "wizard", "step", "stepper"]
  },
  {
    name: "Label",
    keywords: ["Text", "label", "h1", "h2", "h3", "h4", "h5", "h6"]
  },
  {
    name: "Image",
    keywords: ["image", "img", "picture", "photo", "graph"]
  },
  {
    name: "Icon",
    keywords: ["icon", "image"]
  },
  {
    name: "MDViewer",
    keywords: ["md", "markdown", "viewer", "html"]
  },
  {
    name: "Thumbnail",
    keywords: ["thumbnail", "image"]
  },
  {
    name: "VideoPlayer",
    keywords: ["video", "player", "youtube", "vimeo", "movie", "animation"]
  },
  {
    name: "Divider",
    keywords: ["divider", "separator", "line", "border"]
  },
  {
    name: "Page Break",
    keywords: ["divider", "separator", "line", "border"]
  },
  {
    name: "ProgressBar",
    keywords: ["progress", "bar", "progressbar"]
  },
  {
    name: "ProgressCircle",
    keywords: ["progress", "circle", "progresscircle"]
  },
  {
    name: "BarcodeRenderer",
    keywords: ["barcode", "renderer", "code", "2d", "zebra"]
  },
  {
    name: "TextInput",
    keywords: ["text", "input", "field", "box"]
  },
  {
    name: "NumberInput",
    keywords: ["numeric", "input", "field", "box", "decimal", "integer", "number"]
  },
  {
    name: "Email",
    keywords: ["email", "input", "field", "mail"]
  },
  {
    name: "TextArea",
    keywords: ["multiline", "text", "area", "input", "field", "box"]
  },
  {
    name: "Currency",
    keywords: ["currency", "input", "field", "number", "money"]
  },
  {
    name: "Password",
    keywords: ["password", "input", "field", "box", "pass"]
  },
  {
    name: "MDEditor",
    keywords: ["md", "markdown", "editor", "html", "text"]
  },
  {
    name: "Percent",
    keywords: ["percent", "input", "field", "box", "percentage"]
  },
  {
    name: "Url",
    keywords: ["url", "input", "field", "box", "link", "web"]
  },
  {
    name: "AutoComplete",
    keywords: ["places", "auto", "complete", "input", "field", "box", "suggestion", "search"]
  },
  {
    name: "SelectBox",
    keywords: ["select", "box", "dropdown", "list", "combo"]
  },
  {
    name: "MultiSelect",
    keywords: ["multi", "select", "box", "dropdown", "list", "combo"]
  },
  {
    name: "PlacesAutocomplete",
    keywords: ["places", "auto", "complete", "address", "input", "field", "box", "suggestion", "search"]
  },
  {
    name: "Checkbox",
    keywords: ["check", "box", "checkbox", "bool", "boolean", "true", "false"]
  },
  {
    name: "RadioGroup",
    keywords: ["radio", "group", "select", "list"]
  },
  {
    name: "Switch",
    keywords: ["switch", "toggle", "check", "on", "off", "bool", "boolean", "true", "false"]
  },
  {
    name: "Button",
    keywords: ["button", "submit", "navigation", "trigger", "action", "press", "click"]
  },
  {
    name: "DropDown",
    keywords: ["dropdown", "list", "combo", "select", "menu"]
  },
  {
    name: "ContentMenu",
    keywords: ["content", "menu", "profile", "avatar"]
  },
  {
    name: "DatePicker",
    keywords: ["date", "picker", "month", "year", "day", "week", "time", "input", "box"]
  },
  {
    name: "DateRange",
    keywords: ["date", "month", "year", "day", "week", "range", "input", "box"]
  },
  {
    name: "DateTimeRange",
    keywords: ["date", "time", "year", "day", "week", "month", "minute", "second", "hour", "range", "input", "box"]
  },
  {
    name: "Countup",
    keywords: ["count", "up", "stopwatch", "counter", "timer"]
  },
  {
    name: "Countdown",
    keywords: ["count", "down", "stopwatch", "counter", "timer"]
  },
  {
    name: "Table",
    keywords: ["table", "data", "list", "grid", "datagrid", "table", "cell", "filter", "report", "result"]
  },
  {
    name: "GalleryView",
    keywords: ["gallery", "view", "image", "photo", "list", "product", "data"]
  },
  {
    name: "FlexGrid",
    keywords: ["flex", "grid", "layout", "box", "chips", "hashtag"]
  },
  {
    name: "Carousel",
    keywords: ["carousel", "slider", "slide", "slideshow", "image", "photo", "list", "product", "data", "gallery"]
  },
  {
    name: "HorizontalGrid",
    keywords: ["horizontal", "grid", "gallery"]
  },
  {
    name: "Pagination",
    keywords: ["pagination", "page"]
  },
  {
    name: "Area",
    keywords: ["area", "chart"]
  },
  {
    name: "BarcodeRenderer",
    keywords: ["barcode", "renderer", "code", "2d", "zebra"]
  },
  {
    name: "DonutChart",
    keywords: ["donut", "chart"]
  },
  {
    name: "GaugeChart",
    keywords: ["gauge", "chart"]
  },
  {
    name: "LineChart",
    keywords: ["line", "chart"]
  },
  {
    name: "PieChart",
    keywords: ["pie", "chart"]
  },
  {
    name: "Maps",
    keywords: ["google", "maps", "map", "location", "navigation", "geo", "coordinates", "latitude", "longitude"]
  },
  {
    name: "Chat",
    keywords: [
      "chat",
      "message",
      "conversation",
      "conversations",
      "chatroom",
      "chatrooms",
      "group",
      "groups",
      "channel",
      "channels"
    ]
  },
  {
    name: "Signature",
    keywords: ["signature", "draw", "paint"]
  },
  {
    name: "Rate",
    keywords: ["rate", "star", "rating", "evaluate"]
  },
  {
    name: "Language Selector",
    keywords: ["language", "selector", "multilanguage", "select", "lang"]
  },
  {
    name: "FileDownload",
    keywords: ["file", "download", "downloader", "downloads", "file", "files", "fileupload", "fileuploads"]
  },
  {
    name: "CronMaker",
    keywords: ["cron", "schedule", "maker", "job", "jobs", "task", "tasks"]
  },
  {
    name: "QRRenderer",
    keywords: ["qr", "renderer", "code", "render"]
  },
  {
    name: "WebView",
    keywords: ["view", "iframe", "viewer", "url", "html"]
  },
  {
    name: "DynamicInput",
    keywords: ["input", "text", "number", "date", "time"]
  },
  {
    name: "Breadcrumb",
    keywords: ["breadcrumb", "navigation", "menu", "navigation"]
  },
  {
    name: "FloatButton",
    keywords: ["float", "button", "navigation", "menu", "navigation"]
  },
  {
    name: "FloatPanel",
    keywords: ["float", "panel", "navigation", "menu", "navigation"]
  }
];
